import Select from "ol/interaction/Select";
import { click, pointerMove } from "ol/events/condition";
import {
  getLaneCountStyleClick,
  getLaneCountStyleHover,
} from "../style/laneCount";

export function getLaneCountInteractions(layer, control) {
  const clickSelect = new Select({
    layers: [layer],
    condition: click,
    style: function (feature) {
      return getLaneCountStyleClick(feature);
    },
  });
  clickSelect.on("select", function (e) {
    if (e.target.getFeatures().getLength() > 0) {
      control.set(
        "selectedFeatures",
        Array.from(e.target.getFeatures().getArray()),
      );
    } else {
      control.set("selectedFeatures", undefined);
    }
  });
  const hoverSelect = new Select({
    layers: [layer],
    condition: pointerMove,
    style: function (feature) {
      return getLaneCountStyleHover(feature);
    },
  });

  return [clickSelect, hoverSelect];
}
